// units in em
export const breakpoints = {
  mobile: 36,
  smallTablet: 48,
  largeTablet: 63,
  laptop: 75,
  wideScreen: 86.5,
  extraWideScreen: 100,
};
